import React from "react";
import "./AboutSection.css";

// ❌ removed wrong import from public

const features = [
  {
    id: 1,
    icon: (
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
        <path
          d="M16 4C10 4 6 9 6 14c0 5 4 9 10 14 6-5 10-9 10-14 0-5-4-10-10-10z"
          stroke="#3a3a3a"
          strokeWidth="1.5"
        />
        <path
          d="M16 8c-2 0-4 2-4 4"
          stroke="#3a3a3a"
          strokeWidth="1.4"
          strokeLinecap="round"
        />
      </svg>
    ),
    label: "Nature in Everyday Rituals",
  },
  {
    id: 2,
    icon: (
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
        <circle cx="16" cy="16" r="10" stroke="#3a3a3a" strokeWidth="1.5" />
        <path
          d="M12 16c1-2 3-3 4-3s3 1 4 3"
          stroke="#3a3a3a"
          strokeWidth="1.4"
          strokeLinecap="round"
        />
      </svg>
    ),
    label: "Natural Skincare Effectiveness",
  },
  {
    id: 3,
    icon: (
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
        <circle cx="16" cy="16" r="10" stroke="#3a3a3a" strokeWidth="1.5" />
        <path
          d="M16 10c0 0-4 3-4 6s4 6 4 6 4-3 4-6-4-6-4-6z"
          stroke="#3a3a3a"
          strokeWidth="1.4"
        />
      </svg>
    ),
    label: "Harmony for Skin & Senses",
  },
];

const AboutSection = () => {
  return (
    <section className="about-section">
      
      {/* Left Image */}
      <div className="about-image-col">
        <img
          src="/images/newimage4.webp"
          alt="Mokosh cosmetics products"
          className="about-image"
        />
      </div>

      {/* Right Content */}
      <div className="about-content-col">
        <h2 className="about-heading">About Mokosh</h2>

        <p className="about-description">
          Mokosh Cosmetics produces exceptional natural cosmetics that captivate
          with their quality and selection of raw materials, texture, and fragrance.
          The recipes are created by experts to meet real skincare needs.
        </p>

        <ul className="about-features">
          {features.map((feature) => (
            <li key={feature.id} className="about-feature-item">
              <span className="about-feature-icon">{feature.icon}</span>
              <span className="about-feature-label">{feature.label}</span>
            </li>
          ))}
        </ul>
      </div>

    </section>
  );
};

export default AboutSection;